import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCityHall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.9 1.07q-.31.08-.43.35l-.04.1v2.42l-2 1c-2.2 1.1-2.1 1.04-2.2 1.23l-.04.1v1.15h-.84l-.84.01-.1.04q-.09.04-.18.13-.17.16-.16.4-.01.24.16.4c.12.12.22.16.45.17l.18.01v5.21h-.11c-.25 0-.39.05-.52.18q-.2.2-.16.5c.03.13.07.2.16.3q.13.14.3.16l6.53.01h6.43l.1-.04c.12-.05.26-.2.3-.32.05-.11.05-.3.02-.4-.06-.15-.2-.3-.35-.35-.04-.01-.15-.03-.24-.03l-.18-.01V8.58h.12c.24 0 .38-.06.52-.19.15-.16.2-.4.12-.6-.05-.13-.19-.27-.32-.32l-.1-.04h-1.66v-.59l-.01-.58-.05-.09c-.09-.2.01-.14-2.18-1.23l-2-1V2.2h.24l.34-.02c.46-.08.63-.66.29-.97q-.13-.11-.29-.15c-.11-.02-1.17-.02-1.27 0M6.14 5.84l-1.82.92v.33l-.01.33h7.36v-.66l-1.83-.92L8 4.93zM3 11.18v2.61h1.78V8.58H2.99zm2.93 0v2.61h1.5v-.83l.01-.84.05-.1q.1-.2.28-.29c.08-.04.1-.04.24-.04s.16 0 .24.04q.19.1.28.29l.05.1v1.67h1.51V8.58H5.92zm5.31 0v2.61h1.78V8.58h-1.78z"
      fill="#475569"
    />
  </svg>
);
export default SvgIconCityHall;
